// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gv-0";
export var actionModalContentContainer = "_gv-1";
export var createTagButton = "_gv-2";
export var footerContainer = "_gv-7";
export var fullWidthDivider = "_gv-3";
export var hasCreateTagButton = "_gv-4";
export var noCreateTagButton = "_gv-5";
export var tagsContainer = "_gv-6";
export var tagsModalContentContainer = "_gv-8";